import Button from "src/components/Button";
import Card from "src/components/Card";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";

interface NoTeamsCreatedBannerProps extends Translation {
	children?: any;
}

const NoTeamsCreatedBanner = ({ t, children }: NoTeamsCreatedBannerProps) => {
	return (
		<Card>
			<h2 className="mb-2 text-[22px] leading-[22px]">
				<strong>{t("title")}</strong>
			</h2>
			<p>{t("description")}</p>
			<div className="flex items-center flex-col md:flex-row gap-4 mt-4">
				<Button
					type="dark"
					className="w-full md:w-auto"
					to={{
						modal: "/profile/teams/create",
						back: {
							to: "/dashboard",
						},
					}}
				>
					<i className="fas fa-users-medical mr-2"></i>
					{t("buttons.create-team")}
				</Button>
				<Button
					type="gray"
					className="w-full md:w-auto"
					to={{
						modal: "/profile/users/invite",
						back: {
							to: "/dashboard",
						},
					}}
				>
					<i className="fas fa-user-plus mr-2"></i>
					{t("buttons.invite-members")}
				</Button>
			</div>
		</Card>
	);
};

NoTeamsCreatedBanner.locale = {
	nl: {
		title: "Maak je eerste team aan",
		description:
			'Maak een team "Marketing" en nodig al jouw marketing teamleden uit voor een GetJobsDone account. Hierdoor krijg je beter inzicht in de capaciteit van jouw "Marketing" team',
		buttons: {
			"create-team": "Team aanmaken",
			"invite-members": "Teamleden uitnodigen",
		},
	},
	en: {
		title: "Create your first team",
		description:
			'Create a team "Marketing" and invite all your marketing team members for a GetJobsDone account. Manage your marketing team capacity based on their tasks',
		buttons: {
			"create-team": "Create team",
			"invite-members": "Invite members",
		},
	},
};

export default withTranslation(NoTeamsCreatedBanner);
